<template>
  <div id="vlibras-root" class="'desactiveVL'">
    <div vw class="enabled">
      <div vw-access-button class="active"></div>
      <div vw-plugin-wrapper>
        <div class="vw-plugin-top-wrapper"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "VLibras",

  data() {
    return {
      currentPath: window.location.pathname,
      active: true
    };
  },

  watch:{
    currentPath(value) {
      this.activeVlibras(value);
    }
  },

  computed: {
  ...mapGetters({ getVLibras: "getVLibras" }),
  },

  methods: {
    createVlibras() {
      const existingScript = document.querySelector('script[src="https://vlibras.gov.br/app/vlibras-plugin.js"]');
      if (existingScript) {
        existingScript.remove(); // Remove script antigo, se existir
      }
      const script = document.createElement("script");
      script.src = "https://vlibras.gov.br/app/vlibras-plugin.js";
      script.defer = true;
      script.onload = () => {
        console.log("VLibras recarregado!");
        new window.VLibras.Widget();
      };
      document.body.appendChild(script);
    },

    activeVlibras(value){
      const blockRouterNamelist = [
        '/login',
        '/login/:token',
        '/register',
        '/forgot-my-password',
        '/reset-password',
      ];
      
      if (blockRouterNamelist.includes(value)) {
        // alert(value)
        this.active = false;
      }
      this.active = true

    },

    updatePath() {
      this.currentPath = window.location.pathname;
    },

    overrideHistoryMethods() {
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;
      const vm = this;

      history.pushState = function() {
        originalPushState.apply(history, arguments);
        vm.updatePath();
      };

      history.replaceState = function() {
        originalReplaceState.apply(history, arguments);
        vm.updatePath();
      };
    }
  },
  mounted() {
    this.createVlibras();

    window.addEventListener('popstate', this.updatePath);

    this.overrideHistoryMethods();
  },
};
</script>
  
  
<style scoped>
#vlibras-root {
  position: fixed;
  bottom: 50px;
  right: 10px;
  z-index: 9999;
}

[vw] {
  display: block !important;
  position: fixed !important;
  bottom: 50px !important;
  right: 10px !important;
  z-index: 99999 !important;
  visibility: visible !important;
  opacity: 1 !important;
}

[vw-access-button] {
  position: fixed !important;
  bottom: 50px !important;
  right: 10px !important;
  /* width: 60px !important;
  height: 60px !important; */
  z-index: 99999 !important;
}

[vw-access-button] img.access-button {
  width: 100% !important;
  height: auto !important;
  transition: transform 0.3s ease-in-out;
}

[vw-access-button]:hover img.access-button {
  transform: translateX(-10px); /* Move a imagem para esquerda no hover */
}

[vw-access-button] img.pop-up {
  position: absolute;
  top: 0;
  left: 100%;
  width: 200px !important;
  opacity: 0;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

[vw-access-button]:hover img.pop-up {
  opacity: 1;
  transform: translateX(-100%);
}

.activeVL{
  display: block;
}

.desactiveVL{ 
  display: none;
}
</style>
  